import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noPermissionFlagHeader: {
		id: 'backlog.flags.sprint-board-permissionless-flag.no-permission-flag-header',
		defaultMessage: "You don't have permission to access this project",
		description: 'Header text for flag shown when user tries to access a restricted project',
	},
	noPermissionFlagBody: {
		id: 'backlog.flags.sprint-board-permissionless-flag.no-permission-flag-body',
		defaultMessage: 'Speak to your Jira admin or Project admin to get access',
		description: 'Body text for flag shown when user tries to access a restricted project',
	},
});
